const iOSReducerDefaultState = {
    ios: false
};

export default (state = iOSReducerDefaultState, action) => {
    switch (action.type) {
        case 'IS_IOS':
            console.log('IS_IOS');
            return {
                ...state,
                ios: true
            };
        case 'IS_NOT_IOS':
            return {
                ...state,
                ios: false
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/ios.js